import classNames from 'classnames'
import classes from './index.module.css'
import { Link } from 'react-router-dom'
import { Tooltip } from 'antd'
import { ExclamationOutlined, EyeInvisibleOutlined } from '@ant-design/icons'
import { CSSProperties, RefObject } from 'react'
import TooltipWrapper from '@pages/Admin/CourseSettings/components/TooltipWrapper/TooltipWrapper'
import SecondaryButton from '@pages/Admin/CourseSettings/components/SecondaryButton/SecondaryButton'

interface ISurvey {
  id: number
  title: string
  description: string
  regularity: string
  type: string
  order: number
  uuid: string
  report_id: number
  isAnonymous?: boolean
  is_anonymous?: boolean
}

const isEnabledFlag = (value?: boolean | number | string) =>
  value === true || value === 1 || value === '1'

const isAnonymousSurvey = (survey?: ISurvey) =>
  isEnabledFlag(survey?.isAnonymous) ||
  isEnabledFlag(survey?.is_anonymous)

const SurveyCard = ({
  isRequired,
  isPassed,
  isManual = false,
  survey,
  className,
  style,
  fromLesson,
  openLesson,
  forLesson,
  surveyCardRef,
}: {
  isRequired: boolean
  isPassed?: boolean
  isManual?: boolean
  survey: ISurvey
  className?: string
  style?: CSSProperties
  fromLesson?: boolean
  openLesson?: number | null
  forLesson?: number
  surveyCardRef?: RefObject<HTMLDivElement>
}) => {
  const isActive = !isPassed && !!survey?.id

  const baseUrl = `/my-survey-link/${survey?.id}`

  const queryParams = []
  if (openLesson && forLesson) {
    queryParams.push(`openLesson=${openLesson}`)
  }

  if (forLesson) {
    queryParams.push(`forLesson=${forLesson}`)
  }

  const url =
    queryParams.length > 0 ? `${baseUrl}?${queryParams.join('&')}` : baseUrl

  return (
    <div
      ref={surveyCardRef || null}
      className={classNames(classes.surveyContainer, className)}
      style={style}
    >
      <div className={classes.surveyHeader}>
        <div className={classes.surveyHeaderTitle}>Опрос</div>
        {!!isRequired && (
          <TooltipWrapper title="Обязательный опрос. Его прохождение является обязательным для перехода к следующему уроку/теме">
            <div className={classes.requiredMark}>
              <ExclamationOutlined
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            </div>
          </TooltipWrapper>
        )}
      </div>
      <div className={classes.surveyContent}>
        <div className={classes.surveyInfo}>
          <div className={classes.surveyTitle}>
            <span>{survey?.title ?? 'опрос не найден'}</span>
            {isAnonymousSurvey(survey) && (
              <Tooltip title="Анонимный опрос">
                <span className={classes.anonymousMark}>
                  <EyeInvisibleOutlined
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                  />
                </span>
              </Tooltip>
            )}
          </div>
          {survey?.description && (
            <div className={classes.surveyDescription}>
              {survey?.description}
            </div>
          )}
        </div>
        <div className={classes.actionRow}>
          <Link
            to={
              isManual
                ? `/my-survey/${survey?.report_id}/`
                : fromLesson
                ? isActive && url
                : isActive && `/my-survey-link/${survey?.id}/`
            }
          >
            <SecondaryButton className={classes.button} disabled={!isActive} onClick={()=>{}}>
              {isPassed ? 'Уже пройден' : 'Пройти опрос'}
            </SecondaryButton>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default SurveyCard
